function Amex({ className }: { className?: string }): JSX.Element {
  return (
    <svg
      width="36"
      height="24"
      viewBox="0 0 36 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      <rect width="36" height="24" fill="#1E1E1E" />
      <path
        d="M-5530 -2731C-5530 -2732.1 -5529.1 -2733 -5528 -2733H24618C24619.1 -2733 24620 -2732.1 24620 -2731V8605C24620 8606.1 24619.1 8607 24618 8607H-5528C-5529.1 8607 -5530 8606.1 -5530 8605V-2731Z"
        fill="#444444"
      />
      <path
        d="M-5528 -2732H24618V-2734H-5528V-2732ZM24619 -2731V8605H24621V-2731H24619ZM24618 8606H-5528V8608H24618V8606ZM-5529 8605V-2731H-5531V8605H-5529ZM-5528 8606C-5528.55 8606 -5529 8605.55 -5529 8605H-5531C-5531 8606.66 -5529.66 8608 -5528 8608V8606ZM24619 8605C24619 8605.55 24618.6 8606 24618 8606V8608C24619.7 8608 24621 8606.66 24621 8605H24619ZM24618 -2732C24618.6 -2732 24619 -2731.55 24619 -2731H24621C24621 -2732.66 24619.7 -2734 24618 -2734V-2732ZM-5528 -2734C-5529.66 -2734 -5531 -2732.66 -5531 -2731H-5529C-5529 -2731.55 -5528.55 -2732 -5528 -2732V-2734Z"
        fill="white"
        fillOpacity="0.1"
      />
      <g clipPath="url(#clip0_17652_9447)">
        <rect
          width="1440"
          height="1030"
          transform="translate(-1197 -869)"
          fill="#F5F5F5"
        />
        <mask id="path-3-inside-1_17652_9447" fill="white">
          <path d="M-1042 -70H88V44H-1042V-70Z" />
        </mask>
        <path
          d="M-1042 -69H88V-71H-1042V-69Z"
          fill="#E0E0E0"
          mask="url(#path-3-inside-1_17652_9447)"
        />
        <g opacity="0.5">
          <path
            d="M33 0H3C1.34315 0 0 1.34315 0 3V21C0 22.6569 1.34315 24 3 24H33C34.6569 24 36 22.6569 36 21V3C36 1.34315 34.6569 0 33 0Z"
            fill="#016FD0"
          />
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M20.6465 20.0912V11.5391L35.8678 11.5527V13.9151L34.1085 15.7952L35.8678 17.6925V20.1049H33.0589L31.5661 18.4577L30.0839 20.1112L20.6465 20.0912Z"
            fill="#FFFFFE"
          />
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M21.6631 19.1538V12.4805H27.3215V14.0178H23.4952V15.0613H27.2303V16.5731H23.4952V17.598H27.3215V19.1538H21.6631Z"
            fill="#016FD0"
          />
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M27.2931 19.1537L30.4241 15.8132L27.293 12.4805H29.7164L31.6297 14.5955L33.5483 12.4805H35.8676V12.533L32.8033 15.8132L35.8676 19.059V19.1537H33.525L31.5778 17.0174L29.6507 19.1537H27.2931Z"
            fill="#016FD0"
          />
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M21.3563 3.94727H25.0254L26.3141 6.87354V3.94727H30.8438L31.625 6.13962L32.4088 3.94727H35.8677V12.4994H17.5879L21.3563 3.94727Z"
            fill="#FFFFFE"
          />
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M22.0509 4.87695L19.0898 11.5447H21.1207L21.6793 10.2095H24.7062L25.2645 11.5447H27.3458L24.3972 4.87695H22.0509ZM22.3053 8.71311L23.1933 6.5905L24.0807 8.71311H22.3053Z"
            fill="#016FD0"
          />
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M27.3184 11.5426V4.875L30.173 4.88481L31.6419 8.98391L33.1204 4.875H35.8678V11.5426L34.0999 11.5583V6.97825L32.431 11.5426H30.8173L29.1139 6.9626V11.5426H27.3184Z"
            fill="#016FD0"
          />
        </g>
      </g>
      <defs>
        <clipPath id="clip0_17652_9447">
          <rect
            width="1440"
            height="1030"
            fill="white"
            transform="translate(-1197 -869)"
          />
        </clipPath>
      </defs>
    </svg>
  );
}

export default Amex;
